// Add unique key to props
const propsWithUniqueKey = (props, key) => {
  return Object.assign(props || {}, { key })
}

module.exports = propsWithUniqueKey